module.exports = __webpack_public_path__ + "img/delete-active.0709d46b.svg";